import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { a as applySpacingProps } from './p-15440395.js';

const biLinkCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{font-family:\"museo-sans\", arial, sans-serif;font-weight:700;background-color:transparent;display:inline-block}:host a{color:#414651;text-decoration:none;min-height:44px;min-width:44px;--underline-thickness:2px;--underline-color:#0b62c5}:host a.blue{text-decoration-color:#0b62c5;color:#0b62c5}:host a.light{text-decoration-color:#1a77e9;color:whitesmoke;--underline-color:#1a77e9}:host a:focus-visible{border-radius:4px;outline-offset:2px;outline:1.5px solid var(--bi-primary-50);box-shadow:0 0 0 2px white}:host a.xxl{font-size:2rem;line-height:1.5}:host a.xl{font-size:1.5rem;line-height:1.5}:host a.large{font-size:1.25rem;line-height:1.5}:host a.medium{font-size:1rem;line-height:1.5;--underline-thickness:1.5px}:host a.small{font-size:0.75rem;line-height:1.5;--underline-thickness:1px}:host a:hover,:host a.underline{text-decoration:underline var(--underline-thickness) solid var(--underline-color);text-underline-offset:3px}";
const BiLinkStyle0 = biLinkCss;

const BiLink$1 = /*@__PURE__*/ proxyCustomElement(class BiLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * The size of the link, with a default value of 'medium'
         */
        this.size = 'medium';
        /**
         * The state of the link, indicating whether it is underlined or not, with a default value of 'underline'
         */
        this.state = 'underline';
        /**
         * The color of the link, with a default value of 'dark'
         */
        this.color = 'dark';
        /**
         * The target of the link, with a default value of '_self'
         */
        this.target = '_self';
    }
    componentWillLoad() {
        applySpacingProps(this.el, this.top, this.bottom, this.left, this.right);
    }
    render() {
        return (h(Host, { key: '256c1bb42692c78b2ebedcdbede83583093b18d4' }, h("a", { key: 'fac332740ead8c5d796c92b69f01f9c0a5629c17', class: classNames(this.size, this.state, this.color), href: this.href, target: this.target }, h("slot", { key: '13d895d15dddb0bb1d2dfc3ae64baceb40e4870f' }))));
    }
    get el() { return this; }
    static get style() { return BiLinkStyle0; }
}, [1, "bi-link", {
        "href": [1],
        "size": [1],
        "state": [1],
        "color": [1],
        "target": [1],
        "top": [1],
        "bottom": [1],
        "left": [1],
        "right": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-link"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiLink$1);
            }
            break;
    } });
}

const BiLink = BiLink$1;
const defineCustomElement = defineCustomElement$1;

export { BiLink, defineCustomElement };
